// Angular DOM
// Angular Hooks
import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from "@angular/core";
// Redux Store
import {Store} from "@ngrx/store";
import {SetPatientAction, SetTestOrderDetails} from "../../actions";
// Models
import {Patient, TestOrder} from "../../models";
// Third Party services
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
// Services
import {AuthService, PatientService, UtilService} from "../../services";
import {Location} from "@angular/common";

@Component({
  selector: "app-patient-billing-modal",
  templateUrl: "./patient-billing-modal.component.html",
  styleUrls: ["./patient-billing-modal.component.scss"]
})
export class PatientBillingNewModalComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("content") template: TemplateRef<any>;

  public redirect: string;

  public patient: Patient;
  public modalRef: any;
  public confirm: boolean = false;
  public editMode: boolean = false;
  public backButtonText: string = "BACK";
  public modalTitle: string = "Add Patient Billing";
  public isOfficeStaff: boolean;
  public user: User;

  public requestPending: boolean = false;

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-billing",
    container: "app-patient-billing-modal",
    keyboard: false
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    private patientService: PatientService,
    private store: Store<any>,
    private utilService: UtilService,
    private location: Location
  ) {
  }

  cancel() {
    this.store.dispatch({type: "CLEAR_PATIENT"});
    this.store.dispatch({type: "CLEAR_TEST_ORDER"});
    this.router.navigate(["/patients"]);
  }

  ngOnInit() {
    this.user = this.authService.getUser();
    this.isOfficeStaff = false; //this.user.Role === "staff";
    this.route.queryParams.subscribe(params => {
      this.redirect = params["redirect"] || "";
    });
    this.store.select("patient").subscribe(patient => {
      this.patient = Object.assign({}, new Patient(), patient);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  onFacilitySelect(event, elem) {
    this.patient.BillToText = event;
    this.patient.InsurancePolicies[0].BillTo = '';
    elem.focus();
  }

  onFacilityRadioButton(elem) {
    this.patient.InsurancePolicies[0].BillTo = '';
    elem.focus()
  }

  clearFacilityField(){
    this.patient.BillToText = '';
  }

  setConfirm() {
  }

  canSkip() {
    return (
      !(
        this.patient.BillToText ||
        this.patient.InsurancePolicies[0].BillTo ||
        this.patient.InsurancePolicies[0].Provider ||
        this.patient.InsurancePolicies[0].GroupNumber ||
        this.patient.InsurancePolicies[0].PlanNumber
      ) && !this.isOfficeStaff
    );
  }

  back() {
    this.location.back();
  }

  update() {
    if (this.patient.BillToText !== "" && this.patient.BillToText) {
      this.patient.InsurancePolicies[0].BillTo = this.patient.BillToText;
    }
    this.requestPending = true;
    this.patientService.createPatient(this.patient).subscribe(
      createdPatient => {
        this.requestPending = false;
        this.patient.Id = createdPatient.Id;
        this.store.dispatch(
          new SetPatientAction(this.patient, this.utilService)
        );
        if (this.redirect !== "") {
          let testOrder: TestOrder = new TestOrder();
          testOrder.PatientName = `${createdPatient.FirstName}${
            createdPatient.MiddleName ? ` ${createdPatient.MiddleName} ` : " "
            }${createdPatient.LastName}`;
          testOrder.PatientDob = createdPatient.Dob;
          testOrder.PatientId = createdPatient.Id;
          this.store.dispatch(
            new SetTestOrderDetails(testOrder, this.utilService)
          );
        }


        let navigationExtras: NavigationExtras = {
          queryParams: {redirect: this.redirect}
        };
        this.router.navigate(
          ["/patients/create/success"],
          navigationExtras
        );
      },
      err => {
        this.requestPending = false;
        this.router.navigate(["/patients/create/failure"]);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-billing-modal/patient-billing-new-modal.component.ts